import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BabyIcon, ZapIcon, LayoutGridIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.15
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Sistema3B() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-slate)'
  }} data-id="element-255">
      <motion.div className="max-w-[900px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-256">
        <motion.p variants={childVariants} className="text-sm md:text-base font-semibold uppercase tracking-widest mb-4 text-center" style={{
        color: 'var(--color-sage)'
      }} data-id="element-257">
          El mecanismo que hace que esto funcione
        </motion.p>

        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-4 text-center" style={{
        color: 'var(--color-cream)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-258">
          Sistema 3B
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-14 text-center max-w-[600px] mx-auto" style={{
        color: 'var(--color-cream)',
        opacity: 0.7
      }} data-id="element-259">
          Cuando otros planes fallan, el Sistema 3B te mantiene dentro.
        </motion.p>

        {/* Three cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-14" data-id="element-260">
          {/* Bebé */}
          <motion.div variants={childVariants} className="rounded-2xl p-7 md:p-8" style={{
          backgroundColor: 'rgba(168, 181, 160, 0.12)',
          border: '1px solid rgba(168, 181, 160, 0.2)'
        }} data-id="element-261">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.2)'
          }} data-id="element-262">
              <BabyIcon className="w-6 h-6" style={{
              color: 'var(--color-sage)'
            }} data-id="element-263" />
            </div>
            <p className="text-sm font-bold uppercase tracking-wider mb-2" style={{
            color: 'var(--color-sage)'
          }} data-id="element-264">
              B de Bebé
            </p>
            <h3 className="text-xl md:text-2xl mb-3" style={{
            color: 'var(--color-cream)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-265">
              Rutinas anti-interrupciones
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: 'var(--color-cream)',
            opacity: 0.7
          }} data-id="element-266">
              Pausables, simples, reales. Diseñadas para que puedas parar y
              retomar sin perder el hilo.
            </p>
          </motion.div>

          {/* Breves */}
          <motion.div variants={childVariants} className="rounded-2xl p-7 md:p-8" style={{
          backgroundColor: 'rgba(196, 168, 130, 0.12)',
          border: '1px solid rgba(196, 168, 130, 0.2)'
        }} data-id="element-267">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
            backgroundColor: 'rgba(196, 168, 130, 0.2)'
          }} data-id="element-268">
              <ZapIcon className="w-6 h-6" style={{
              color: 'var(--color-tan)'
            }} data-id="element-269" />
            </div>
            <p className="text-sm font-bold uppercase tracking-wider mb-2" style={{
            color: 'var(--color-tan)'
          }} data-id="element-270">
              B de Breves
            </p>
            <h3 className="text-xl md:text-2xl mb-3" style={{
            color: 'var(--color-cream)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-271">
              Plan de emergencia 2–4 min
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: 'var(--color-cream)',
            opacity: 0.7
          }} data-id="element-272">
              Para días imposibles. No abandonas — haces lo mínimo y sigues
              dentro del sistema.
            </p>
          </motion.div>

          {/* Bloques */}
          <motion.div variants={childVariants} className="rounded-2xl p-7 md:p-8" style={{
          backgroundColor: 'rgba(168, 181, 160, 0.12)',
          border: '1px solid rgba(168, 181, 160, 0.2)'
        }} data-id="element-273">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.2)'
          }} data-id="element-274">
              <LayoutGridIcon className="w-6 h-6" style={{
              color: 'var(--color-sage)'
            }} data-id="element-275" />
            </div>
            <p className="text-sm font-bold uppercase tracking-wider mb-2" style={{
            color: 'var(--color-sage)'
          }} data-id="element-276">
              B de Bloques
            </p>
            <h3 className="text-xl md:text-2xl mb-3" style={{
            color: 'var(--color-cream)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-277">
              A/B/C para retomar sin culpa
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: 'var(--color-cream)',
            opacity: 0.7
          }} data-id="element-278">
              Sin perderte, sin "arruinar la semana". Siempre sabes dónde estás
              y cómo seguir.
            </p>
          </motion.div>
        </div>

        <motion.p variants={childVariants} className="text-center text-xl md:text-2xl" style={{
        color: 'var(--color-cream)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-279">
          Esto elimina el enemigo #1 de las mamás:{' '}
          <span style={{
          color: 'var(--color-tan)'
        }} data-id="element-280">
            la mentalidad todo-o-nada.
          </span>
        </motion.p>
      </motion.div>
    </section>;
}